import { AppButton } from 'components';
import useConvertTex from 'hooks/API/POST/useConvertTex';
import { memo } from 'react';
import { VscServerProcess } from 'react-icons/vsc';

function EquationBox({ equation, setEquation, showProcessButton = true }) {
  const { isLoading, mutateAsync } = useConvertTex();

  async function handleProcess() {
    try {
      if (!equation) return;

      const { data } = await mutateAsync({ text: equation });
      setEquation(data);
    } catch (error) {
      setEquation('');
      // console.log('### handleProcess :: error :: ', error?.response?.data?.error);
    }
  }

  return (
    <>
      <textarea
        rows="10"
        value={equation}
        onChange={(event) => setEquation(event.target.value)}
        placeholder="Insert your latex equation here followed and terminated by !!"
      />
      {showProcessButton && (
        <AppButton variantClass="btn-plane" onClick={handleProcess} disabled={isLoading}>
          <VscServerProcess />
          {isLoading ? 'Processing' : 'Process'}
        </AppButton>
      )}
    </>
  );
}

export default memo(EquationBox);
